<template>
  <svg
    id="Layer_1"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 1920 1143"
    style="enable-background: new 0 0 1920 1143;"
    xml:space="preserve"
    preserveAspectRatio="none"
  >
    <line
      id="Line_23"
      fill="none"
      :stroke="color"
      x1="161"
      y1="0"
      x2="161"
      y2="1143"
    />
    <line
      id="Line_23-2"
      fill="none"
      :stroke="color"
      x1="321"
      y1="0"
      x2="321"
      y2="1143"
    />
    <line
      id="Line_23-3"
      fill="none"
      :stroke="color"
      x1="481"
      y1="0"
      x2="481"
      y2="1143"
    />
    <line
      id="Line_23-4"
      fill="none"
      :stroke="color"
      x1="641"
      y1="0"
      x2="641"
      y2="1143"
    />
    <line
      id="Line_23-5"
      fill="none"
      :stroke="color"
      x1="801"
      y1="0"
      x2="801"
      y2="1143"
    />
    <line
      id="Line_23-6"
      fill="none"
      :stroke="color"
      x1="961"
      y1="0"
      x2="961"
      y2="1143"
    />
    <line
      id="Line_23-7"
      fill="none"
      :stroke="color"
      x1="1121"
      y1="0"
      x2="1121"
      y2="1143"
    />
    <line
      id="Line_23-8"
      fill="none"
      :stroke="color"
      x1="1281"
      y1="0"
      x2="1281"
      y2="1143"
    />
    <line
      id="Line_23-9"
      fill="none"
      :stroke="color"
      x1="1441"
      y1="0"
      x2="1441"
      y2="1143"
    />
    <line
      id="Line_23-10"
      fill="none"
      :stroke="color"
      x1="1601"
      y1="0"
      x2="1601"
      y2="1143"
    />
    <line
      id="Line_23-11"
      fill="none"
      :stroke="color"
      x1="1761"
      y1="0"
      x2="1761"
      y2="1143"
    />
    <line
      id="Line_24"
      fill="none"
      :stroke="color"
      x1="0"
      y1="161"
      x2="1920"
      y2="161"
    />
    <line
      id="Line_24-2"
      fill="none"
      :stroke="color"
      x1="0"
      y1="323"
      x2="1920"
      y2="323"
    />
    <line
      id="Line_24-3"
      fill="none"
      :stroke="color"
      x1="0"
      y1="485"
      x2="1920"
      y2="485"
    />
    <line
      id="Line_24-4"
      fill="none"
      :stroke="color"
      x1="0"
      y1="647"
      x2="1920"
      y2="647"
    />
    <line
      id="Line_24-5"
      fill="none"
      :stroke="color"
      x1="0"
      y1="809"
      x2="1920"
      y2="809"
    />
    <line
      id="Line_24-6"
      fill="none"
      :stroke="color"
      x1="0"
      y1="971"
      x2="1920"
      y2="971"
    />
  </svg>
</template>

<script>
export default {
  name: 'TheGrid',
  props: {
    color: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
svg {
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
}
</style>
